import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CxTableService } from '../../services/cx-table.service';

@Component({
    selector: 'cx-export-modal',
    templateUrl: 'export-modal.component.html',
})
export class ExportModalComponent {
    @Output() close = new EventEmitter();
    @Output() export = new EventEmitter();

    exportOption = 'current-view-data';
    exportOptions = [
        { name: 'Current View Data', value: 'current-view-data' },
        { name: 'All Data', value: 'all-data' },
    ]

    location = 'local';
    locations = [
        { name: 'Local', value: 'local' },
        { name: 'Downlaod', value: 'download' },
    ]

    fileType = 'csv';
    fileTypes = [
        { name: 'csv', value: 'csv' },
        { name: 'xlsx', value: 'xlsx' },
        { name: 'pdf', value: 'xlsx' },
    ]
    emailAddresses = [];
    constructor (public tableService: CxTableService) {}

    onClose(e: MouseEvent) {
        e.preventDefault();
        this.close.emit('');
    }

    onExport (e: MouseEvent) {
        e.preventDefault();
        this.export.emit({ location: this.location, type: this.fileType, limit: this.exportOption });
    }
}
